









































import Vue from 'vue';
import { Icon, Toast } from '@/components/ds';
import CourseModal from './modals/CourseModal.vue';
import CampusModal from './modals/CampusModal.vue';

interface Data {
  courseModalActive: boolean;
  campusModalActive: boolean;
  errorMessageLabel: string;
}

export default Vue.extend({
  components: { Icon, CourseModal, CampusModal, Toast },
  data(): Data {
    return {
      courseModalActive: false,
      campusModalActive: false,
      errorMessageLabel: '',
    };
  },
  computed: {
    courseName(): string {
      return this.$store.getters.courseName ?? '';
    },
    hasCampus(): boolean {
      return !!this.$store.getters.campus;
    },
    campusTitle(): string {
      const { campus } = this.$store.getters;
      if (!campus) return '';
      return `${campus?.name}, ${campus?.city} - ${campus?.state}`;
    },
    campusEmptyStateMessage(): string {
      // sem polo e sem como trocar pela UI, o unico caminho e o atendimento
      return this.canChangeCourseCampus
        ? this.$t('campusEmptyState.message').toString()
        : this.$t('campusEmptyState.supportMessage').toString();
    },
    // No ProUni curso e polo vêm travados da allowlist e já foram provisionados
    // na admissão — trocar aqui desfaria a bolsa. O sinal vem do tipo da admissão,
    // não do texto do cupom (o código do JACAD não tem prefixo).
    isProuniEnrollment(): boolean {
      return this.$store.getters.isProuniEnrollment === true;
    },
    canChangeCourseCampus(): boolean {
      const academicRecord = this.$store.getters.backofficeStudentAcademicRecord ?? null;
      const isJacadCourse = this.$store.getters.isJacadCourse === true;
      return !academicRecord && !isJacadCourse && !this.isProuniEnrollment;
    },
  },
  methods: {
    closeCourseModal() {
      this.courseModalActive = false;
    },
    openCourseModal() {
      this.courseModalActive = true;
    },
    closeCampusModal() {
      this.campusModalActive = false;
    },
    openCampusModal() {
      this.campusModalActive = true;
    },
    triggerError(errorMessageLabel: string) {
      this.errorMessageLabel = errorMessageLabel;

      setTimeout(() => {
        this.errorMessageLabel = '';
      }, 3000);
    },
  },
});
